export default __webpack_public_path__ + "static/media/spotbg1.dab4750b.png";